import React from 'react'
import DisplayExitStaffs from '../components/StaffBioData/DisplayExitStaffs'

export default function ExistingWorker() {
  return (
    <div className="layout-body">
    <DisplayExitStaffs/>
    </div>
  )
}
